import { mapGetters } from 'vuex';

// Singleton instance
const tapAudio = new Audio('/audio/tap.wav');
tapAudio.preload = 'auto';
tapAudio.load();

export const interactionSound = {
  computed: {
    ...mapGetters({
      soundsEnabled: 'location/soundsEnabled',
    }),
  },
  methods: {
    playInteractionSound() {
      if (this.soundsEnabled) {
        tapAudio.currentTime = 0;
        tapAudio.play().catch(error => {
            // Quietly handle errors, common on first load if no interaction yet
           if (process.env.NODE_ENV === 'development') {
             console.warn("Audio play failed (normal if no interaction yet):", error);
           }
        });
      }
    },
  },
};
